import { PGBossJobState } from 'types/pgboss'

export const DEFAULT_BENCHMARK_LABEL = 'Default - Live Table'

export const isTerminal = (status: PGBossJobState): boolean =>
  [
    PGBossJobState.COMPLETED,
    PGBossJobState.FAILED,
    PGBossJobState.CANCELLED,
    PGBossJobState.EXPIRED,
  ].includes(status)

export function getBenchmarkLabel(
  benchmarkSnapshotOptions: { value: number | null; label: string }[],
  benchmarkId: string
) {
  if (!benchmarkId) {
    return DEFAULT_BENCHMARK_LABEL
  }
  return (
    benchmarkSnapshotOptions.find((opt) => opt.value === Number(benchmarkId))
      ?.label ?? DEFAULT_BENCHMARK_LABEL
  )
}
